export const VERIFICATION = {
  FEATURE: {
    REGISTER: "register",
    PROFILE_VERIFIED: "profile_verified",
    FORGOT_PASSWORD: "forgot_password",
  },
  STATUS: {
    PENDING: "pending",
    FAILED: "failed",
    SUCCESS: "success",
  },
  SOURCE: {
    EMAIL: "email",
    PHONE: "phone",
  },
  EXPIRED: 5 * 60, // seconds
  RESEND: 1 * 60, // seconds
};
